import {Controller} from '@hotwired/stimulus';

export default class SidebarController extends Controller {
    static targets = ["menu", "menuGroup"]

    static values = {
        type: {type: String, default: 'date'},
        label: {type: String},
    };

    connect() {
        // console.log('SidebarController.connect');
        window.$('.group-list > a').trigger('click');
        window.$('[data-close-on-click]').on('click', function () {
            window.$('#offCanvasMenu').foundation('close');
        });

        this.element.querySelectorAll("[data-sidebar-target='menuGroup']").forEach((a) => {
            // console.log("adding click handler to ", a)
            // a.addEventListener('click', this.toggle);

            const menuGroup = a.dataset.sidebarLabelValue || a.textContent.trim();
            const storedMenuGroupJson = localStorage.getItem('sidebar-menu-group')
            const storedMenuGroup = storedMenuGroupJson ? JSON.parse(storedMenuGroupJson) : {}
            const isActive = storedMenuGroup[menuGroup]
            // console.log("setting up", menuGroup, isActive);
            if (isActive) {
                // console.log("opening submenu")
                a.nextElementSibling.classList.add('is-active');
                a.nextElementSibling.style.display = "flex";
                a.nextElementSibling.setAttribute("aria-expanded", true);
                // jQuery(this.menuTarget).foundation('down', jQuery(a.nextElementSibling));
            } else {
                // console.log("closing submenu")
                a.nextElementSibling.classList.remove('is-active');
                a.nextElementSibling.style.display = "none";
                a.nextElementSibling.setAttribute("aria-expanded", false);
                // jQuery(this.menuTarget).foundation('up', jQuery(a.nextElementSibling));
            }
        })
    }

    toggle(evt) {
        const menuGroup = evt.target.dataset.sidebarLabelValue ||  evt.target.textContent.trim();
        // console.log("toggling", menuGroup, evt.target);
        const storedMenuGroupJson = localStorage.getItem('sidebar-menu-group')
        const storedMenuGroup = storedMenuGroupJson ? JSON.parse(storedMenuGroupJson) : {}
        storedMenuGroup[menuGroup] = !!!storedMenuGroup[menuGroup]
        localStorage.setItem('sidebar-menu-group', JSON.stringify(storedMenuGroup));
    }
}
